import Cookies from 'js-cookie'

// token key
const TokenKey = 'token'

// sn 验证参数
const SnKey = 'sn'

/**
 * 设置一个sessionStorage的值
 *
 * */
export function setSession(k, v) {
  return sessionStorage.setItem(k, v)
}


/**
 * 设置一个Cookies的值
 *
 * */
export function setCookies(k, v) {
  return Cookies.set(k, v)
}

/**
 * 设置一个Cookies的值
 *
 * */
export function setCookiesId(v) {
  return Cookies.set(TokenKey, v)
}

/**
 * 获取一个sessionStorage的值
 *
 * */
export function getSession(k) {
  return sessionStorage.getItem(k)
}

/**
 * 删除一个sessionStorage的值
 * */
export function removeSession(k) {
  return sessionStorage.removeItem(k)
}

/**
 * 设置一个cookie的值
 *
 * */
export function setCookie(k, v) {
  return Cookies.set(k, v)
}

/**
 * 删除一个cookie的值
 * */
export function removeCookie(k) {
  return Cookies.remove(k)
}

/**
 * 获取token  sessionStorage or cookies
 * */
export function getToken() {
  return sessionStorage.getItem(TokenKey) ? sessionStorage.getItem(TokenKey) : Cookies.get(TokenKey)
}

/**
 * @param token token值
 * 设置token 传递一个token值  设置cookie和sessionStorage
 * */
export function setToken(token) {
  return Cookies.set(TokenKey, token) | sessionStorage.setItem(TokenKey, token)
}

/**
 * 删除一个token 删除cookie和sessionStorage
 * */
export function removeToken() {
  return Cookies.remove(TokenKey) | sessionStorage.removeItem(TokenKey)
}

/**
 * 获取sn
 * */
export function getSn() {
  return sessionStorage.getItem(SnKey)
}

/**
 * 设置sn
 * sn sn的参数
 * */
export function setSn(sn) {
  return sessionStorage.setItem(SnKey, sn)
}

/**
 * 删除sn
 * */
export function removeSn() {
  return sessionStorage.removeItem(SnKey)
}


export function mapToJson(map) {
  let obj = Object.create(null)
  for (let [k, v] of map) {
    obj[k] = v
  }
  return obj
}

export function getId(n) {
  let rnd = ''
  for (let i = 0; i < n; i++)
    rnd += Math.floor(Math.random() * 10)
  return rnd
}

// 验证是否有相同的打球人
export function checkArrayRepeat(arr, personNum) {
  if (arr.length <= 0) return false
  let s = new Set()
  arr.map(v => {
    v.data.forEach(d => {
      if (d.name && d.name !== '') {
        s.add(d.name)
      }
    })
  })
  return s.size === personNum
}
